import React from 'react';
import { ZapIcon, ShieldIcon, ActivityIcon } from 'lucide-react';
export function HowItWorksSection() {
  return <section className="bg-muted py-16 sm:py-24" data-id="element-326">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-327">
        <div className="text-center mb-12" data-id="element-328">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground" data-id="element-329">
            Cómo Se Usa Trimora
          </h2>
          <p className="mt-3 text-muted-foreground text-lg max-w-xl mx-auto" data-id="element-330">
            Tan sencillo como abrir, beber y repetir. Un ritual de 21 días con 7
            ampollas bebibles.
          </p>
        </div>

        {/* Usage steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14" data-id="element-331">
          {/* Step 1 */}
          <div className="bg-card rounded-2xl p-8 shadow-sm border border-border flex flex-col items-center text-center gap-4 relative" data-id="element-332">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-md" data-id="element-333">
              1
            </div>
            <div className="w-16 h-16 bg-green-50 rounded-2xl flex items-center justify-center mt-2" data-id="element-334">
              <span className="text-3xl" data-id="element-335">💧</span>
            </div>
            <h3 className="text-xl font-bold text-foreground" data-id="element-336">
              Abre la Ampolla
            </h3>
            <p className="text-muted-foreground leading-relaxed" data-id="element-337">
              Cada caja contiene <strong data-id="element-338">7 ampollas</strong> de solución oral
              líquida GLP-1+NAD+. Abre una ampolla con facilidad — sin agujas,
              sin pastillas.
            </p>
          </div>

          {/* Step 2 */}
          <div className="bg-card rounded-2xl p-8 shadow-sm border border-border flex flex-col items-center text-center gap-4 relative" data-id="element-339">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-md" data-id="element-340">
              2
            </div>
            <div className="w-16 h-16 bg-green-50 rounded-2xl flex items-center justify-center mt-2" data-id="element-341">
              <span className="text-3xl" data-id="element-342">🥤</span>
            </div>
            <h3 className="text-xl font-bold text-foreground" data-id="element-343">
              Bébela Directamente
            </h3>
            <p className="text-muted-foreground leading-relaxed" data-id="element-344">
              Toma el contenido de la ampolla directamente. Sabor agradable,
              absorción rápida. Sin preparación, sin complicaciones.
            </p>
          </div>

          {/* Step 3 */}
          <div className="bg-card rounded-2xl p-8 shadow-sm border border-border flex flex-col items-center text-center gap-4 relative" data-id="element-345">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-md" data-id="element-346">
              3
            </div>
            <div className="w-16 h-16 bg-green-50 rounded-2xl flex items-center justify-center mt-2" data-id="element-347">
              <span className="text-3xl" data-id="element-348">📅</span>
            </div>
            <h3 className="text-xl font-bold text-foreground" data-id="element-349">
              Repite 21 Días
            </h3>
            <p className="text-muted-foreground leading-relaxed" data-id="element-350">
              Una ampolla cada <strong data-id="element-351">3 días</strong> durante 21 días completan
              el ciclo. Resultados visibles desde la primera semana.
            </p>
          </div>
        </div>

        {/* Mechanism cards */}
        <div className="text-center mb-8" data-id="element-352">
          <h3 className="text-2xl font-bold text-foreground" data-id="element-353">
            Cómo Actúa en Tu Cuerpo
          </h3>
          <p className="mt-2 text-muted-foreground" data-id="element-354">
            Tres mecanismos clave para apoyar tu bienestar diario.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-355">
          <div className="bg-card rounded-2xl p-8 shadow-sm border border-border flex flex-col items-center text-center gap-4" data-id="element-356">
            <div className="w-16 h-16 bg-green-50 rounded-2xl flex items-center justify-center" data-id="element-357">
              <ZapIcon className="w-8 h-8 text-green-600" data-id="element-358" />
            </div>
            <h3 className="text-xl font-bold text-foreground" data-id="element-359">
              Apoya la Saciedad Natural
            </h3>
            <p className="text-muted-foreground leading-relaxed" data-id="element-360">
              La fórmula líquida se absorbe rápidamente, activando las señales
              de saciedad y reduciendo la necesidad de picar entre horas.
            </p>
          </div>

          <div className="bg-card rounded-2xl p-8 shadow-sm border border-border flex flex-col items-center text-center gap-4" data-id="element-361">
            <div className="w-16 h-16 bg-green-50 rounded-2xl flex items-center justify-center" data-id="element-362">
              <ShieldIcon className="w-8 h-8 text-green-600" data-id="element-363" />
            </div>
            <h3 className="text-xl font-bold text-foreground" data-id="element-364">
              Reduce Antojos Constantes
            </h3>
            <p className="text-muted-foreground leading-relaxed" data-id="element-365">
              Especialmente por la tarde y noche, cuando los antojos son más
              difíciles de controlar.
            </p>
          </div>

          <div className="bg-card rounded-2xl p-8 shadow-sm border border-border flex flex-col items-center text-center gap-4" data-id="element-366">
            <div className="w-16 h-16 bg-green-50 rounded-2xl flex items-center justify-center" data-id="element-367">
              <ActivityIcon className="w-8 h-8 text-green-600" data-id="element-368" />
            </div>
            <h3 className="text-xl font-bold text-foreground" data-id="element-369">
              Favorece el Metabolismo
            </h3>
            <p className="text-muted-foreground leading-relaxed" data-id="element-370">
              Apoya el equilibrio metabólico diario para que tu cuerpo funcione
              de forma más eficiente durante todo el ciclo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}